import { useLocation } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { remark } from 'remark';
import html from 'remark-html';
import PostCard from '../components/Blog/PostCard';
import { fetchPosts } from '../services/api';
import { Post } from '../types/types';

export default function Blog() {
  const [posts, setPosts] = useState<Post[]>([]);
  const location = useLocation();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) {
      return;
    }

    const loadPosts = async () => {
      try {
        const rawPosts = await fetchPosts();
        const processedPosts = await Promise.all(
          rawPosts.map(async (post: any) => {
            const processedContent = await remark()
              .use(html)
              .process(post.content);
            let htmlContent = processedContent.toString();
            htmlContent = htmlContent.replace(
              /{%\s*include youtube\.html id="(.+?)"\s*%}/g,
              (_, videoId) => `
                <div class="aspect-w-16 aspect-h-9">
                  <iframe
                    src="https://www.youtube.com/embed/${videoId}"
                    title="YouTube video"
                    allowfullscreen
                    class="w-full h-64 rounded-lg"
                  ></iframe>
                </div>`
            );
            return {
              id: post.id,
              title: post.title,
              date: post.date,
              content: htmlContent,
            };
          })
        );
        setPosts(
          processedPosts.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
          )
        );
      } catch (error) {
        console.error('Error loading posts:', error);
      }
    };

    loadPosts();
    initialized.current = true;
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location, posts]);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 dark:text-gray-200">
      <h2 className="text-4xl text-center font-bold mb-8">Blog</h2>
      {posts.map((post, index) => (
        <PostCard key={index} {...post} />
      ))}
    </div>
  );
}
